import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import { PageProps } from "@/types";
import { Head, Link } from "@inertiajs/react";

export default function Help({ auth }: PageProps) {
    return (
        <>
            <Head title="Pomoc" />
            <div className="min-h-screen bg-gradientMain relative flex flex-col justify-center">
                <div className='absolute top-0 w-full z-10 h-[52.3%] max-h-[630px] object-cover object-center bg-[url(@static/accord-symbol-pattern.svg)]'></div>

                <header className='maxMd:px-4 maxMd:pt-6 maxMd:pb-4 px-14 flex justify-between z-20 relative py-6 items-center maxMd:mb-6 mb-18'>
                    <Link href={auth.user != null ? '/aplikacja' : '/'} title='Strona główna'>
                        <img src='/storage/static/accord-logo-full.svg' className='maxMd:max-w-[105px] max-w-40 w-full h-auto' />
                    </Link>
                    {/* <div>
                        <Link href={route('login')} className='outline-btn border-accordorange border-1'>
                            Zaloguj się
                        </Link>
                    </div> */}
                </header>

                <main className='relative z-20 maxMd:mb-10'>
                    <Container>
                        <Row className="justify-center">
                            <Column xl={8} className="text-center mb-30 maxMd:mb-10">
                                <h1 className="h1 text-arcticMist">Pomoc i wsparcie</h1>
                            </Column>
                            <Column xl={6} className="text-center">
                                <p className="text-body text-arcticMist tracking-[0.27px] mb-8">
                                    Dziękujemy za odwiedzenie naszej platformy Accord Academy. <br /> Jeśli napotkałeś jakiekolwiek trudności lub masz pytania dotyczące korzystania z naszych usług, jesteśmy tutaj, aby Ci pomóc. Nasz zespół wsparcia jest gotowy do udzielenia pomocy w zakresie wszelkich problemów technicznych, pytania dotyczące materiałów oraz nawigacji po platformie.
                                </p>
                                <p className="text-body text-arcticMist tracking-[0.27px] mb-8">
                                    Aby skontaktować się z nami, wystarczy wysłać wiadomość na adres e-mail: <a className="text-accordorange" href="mailto:support@f2fdigital.pl">support@f2fdigital.pl</a>
                                </p>
                                <p className="text-body text-arcticMist tracking-[0.27px]">
                                    Dokładamy wszelkich starań, aby odpowiadać na zapytania w możliwie najkrótszym czasie. Zachęcamy do kontaktu, niezależnie od tego, czy potrzebujesz szybkiej porady, czy bardziej szczegółowych informacji
                                </p>
                            </Column>
                        </Row>
                    </Container>
                </main>

                <footer className='px-14 maxMd:py-4 flex flex-wrap maxMd:gap-y-4 justify-center z-20 relative py-5 items-center gap-x-10 mt-auto'>
                    <Link href={route('front.privacyPolicy')} target='_blank' title='Polityka prywatności' className='text-royalPeriwinkle text-16 leading-6 tracking-[0.24px] maxMd:w-full maxMd:text-center'>
                        Polityka prywatności
                    </Link>
                    <Link href={route('front.terms')} target='_blank' title='Regulamin serwisu' className='text-royalPeriwinkle text-16 leading-6 tracking-[0.24px] maxMd:w-full maxMd:text-center'>
                        Regulamin serwisu
                    </Link>
                    <Link href={route('front.help')} title='Pomoc' className='text-royalPeriwinkle text-16 leading-6 tracking-[0.24px] maxMd:w-full maxMd:text-center'>
                        Pomoc
                    </Link>
                    <a target="_blank" href={`https://www.accord-healthcare.com/pl/`} title='Pomoc' className='md:w-auto w-full inline-block md:text-left text-center md:mt-0 mt-4 text-royalPeriwinkle text-16 tracking-[0.24px] transition-theme hover:text-accordorange'>
                        Mój Accord
                    </a>
                </footer>
            </div>
        </>
    )
}